import moment from "moment";

//Tanslates R1S site and pass type definitions into usable information
export default class R1Stranslator {
  calculateEndDate(passDefinition, pass) {
    //TODO pass in season dates
    if (!pass.passtype) {
      return moment().format("MM/DD/YYYY");
    }
    let passTypeDefinition = passDefinition.pass_types.find(
      type => type.id === pass.passtype
    );

    let durationParts = passTypeDefinition.duration.split(",");
    let duration = durationParts[0].trim();
    //TODO: use the second part of duration to determine the earliest season date instead of hard coding
    // let durationModifier = null;
    // if (durationParts.length > 1) {
    //   durationModifier = durationParts[1];
    // }

    let startDate = moment();
    if (pass["start-date"]) {
      startDate = moment(pass["start-date"], "MM/DD/YYYY");
    }

    if (duration === "7-day") {
      let enddate = moment(startDate);
      enddate.add(6, "days");
      return enddate.format("MM/DD/YYYY");
    }

    if (duration === "14-day") {
      let enddate = moment(startDate);
      enddate.add(13, "days");
      //TODO: Make this not Yuma specific
      if (
        enddate > moment("04/15/" + enddate.year(), "MM/DD/YYYY") &&
        enddate < moment("09/15/" + enddate.year(), "MM/DD/YYYY")
      ) {
        enddate = moment("04/15/" + enddate.year(), "MM/DD/YYYY");
      }
      return enddate.format("MM/DD/YYYY");
    }

    if (duration === "3-day") {
      let enddate = moment(startDate);
      enddate.add(2, "days");
      //TODO: Make this not Wayne specific
      if (enddate > moment("12/15/" + enddate.year(), "MM/DD/YYYY")) {
        enddate = moment("12/15/" + enddate.year(), "MM/DD/YYYY");
      }
      return enddate.format("MM/DD/YYYY");
    }

    if (duration === "1-day") {
      let enddate = moment(startDate);
      return enddate.format("MM/DD/YYYY");
    }

    if (duration === "12-month") {
      let enddate = moment(startDate);
      enddate.add(12, "months");
      enddate.add(1, "days");
      return enddate.format("MM/DD/YYYY");
    }

    if (duration === "season") {
      //Wayne
      if (pass.siteId === "74453") {
        let currentYear = moment().year();
        let wayneEndDate = moment(currentYear + "-12-15", "YYYY-MM-DD");
        return wayneEndDate.format("MM/DD/YYYY");
      }

      //Yuma
      if (pass.siteId === "eb34b293-bd2b-4120-b6fa-c18be8184a67") {
        let currentYear = moment().year();
        if (moment() > moment(currentYear + "-04-15", "YYYY-MM-DD")) {
          currentYear++;
        }
        let yumaEndDate = moment(currentYear + "-04-15", "YYYY-MM-DD");
        return yumaEndDate.format("MM/DD/YYYY");
      }

      //Sharkey
      if (pass.siteId === "15034") {
        let currentYear = moment().year();
        let sharkeyEndDate = moment(currentYear + "-12-31", "YYYY-MM-DD");
        return sharkeyEndDate.format("MM/DD/YYYY");
      }
    }

    if (duration === "segment") {
      //Lake Havasu
      if (pass.enddate) {
        return pass.enddate;
      } else {
        return moment(startDate, "MM/DD/YYYY").format("MM/DD/YYYY");
      }
    }

    if (duration === "annual") {
      let enddate = moment();
      enddate.add(1, "year").endOf("month");
      return enddate.format("MM/DD/YYYY");
    }
  }

  calculateStartDate(duration, pass) {
    if (duration === "annual") {
      return moment().format("MM/DD/YYYY");
    }
    //Wayne
    if (pass.siteId === "74453" && duration === "season") {
      let currentYear = moment().year();
      return moment(currentYear + "-04-15", "YYYY-MM-DD").format("MM/DD/YYYY");
    }
    //Yuma
    if (
      pass.siteId === "eb34b293-bd2b-4120-b6fa-c18be8184a67" &&
      duration === "season"
    ) {
      let currentYear = moment().year();
      if (moment() < moment.utc(currentYear + "-04-15", "YYYY-MM-DD")) {
        currentYear--;
      }

      return moment(currentYear + "-09-15", "YYYY-MM-DD").format("MM/DD/YYYY");
    }
    return pass["start-date"];
  }

  getSku(pass, passDefinition) {
    if (!pass.passtype) {
      return;
    }

    //Get metadata for pass type
    let passTypeMetadata = passDefinition.pass_types.find(
      n => n.id == pass.passtype
    );

    return passTypeMetadata.sku;
  }

  getDescription(pass, passDefinition) {
    if (!pass.passtype) {
      return;
    }

    //Get metadata for pass type
    let passTypeMetadata = passDefinition.pass_types.find(
      n => n.id == pass.passtype
    );

    return passTypeMetadata.name;
  }

  getPrice(pass, passDefinition) {
    if (!pass.passtype) {
      return;
    }

    //Get metadata for pass type
    let passTypeMetadata = passDefinition.pass_types.find(
      n => n.id == pass.passtype
    );

    //Get current period based on start date
    let startDate = moment.utc(pass["start-date"]);
    let dates = passTypeMetadata.periods
      .map(period => {
        if (startDate >= moment(period.start_date)) {
          return moment(period.start_date);
        }
      })
      .filter(n => n != null);
    let periodDate = Math.max.apply(null, dates);
    let period = passTypeMetadata.periods.find(period => {
      return moment(period.start_date).format() == moment(periodDate).format();
    });

    //Get current division
    let divisionDates = period.divisions.map(division => {
      let starts_at = moment.utc(
        division.starts_at + "-" + startDate.year(),
        "MM-DD-YYYY"
      );
      let ends_at = moment.utc(
        division.ends_at + "-" + startDate.year(),
        "MM-DD-YYYY"
      );
      return {
        starts_at: starts_at,
        ends_at: ends_at,
        price: division.price,
        display_price: division.display_price
      };
    });

    let division = divisionDates.find(division => {
      return (
        startDate.startOf("day") >= division.starts_at &&
        startDate.startOf("day") <= division.ends_at
      );
    });

    if (!division) {
      return {
        value: "unavailable",
        displayValue: ""
      };
    }

    let price = {
      value: division.price,
      displayValue: division.display_price
    };

    return price;
  }

  //TODO: calculate start and end season dates based on periods/divisions instead of hardcoding YUMA and Wayne seasons
  // getCurrentOrNextSeasonDates(periods, startdate) {}

  getLicensePlateDefaults(passDefinition, pass) {
    if (pass.vehicletype === "rental" || pass.vehicletype === "n/a") {
      return "N/A";
    }
    return "";
  }
}
